export function offsetValue(numberValue: string, offset: number) {
  return (Number.parseFloat(numberValue) + offset).toString();
}
